export default class InputsHelper {
	public static getAriaDescribedBy(id: string, tooltip?: string, subDescription?: string) {
		const tooltipId = `${id}-tooltip`;
		const subDescriptionId = `${id}-sub-description`;

		if (tooltip) {
			return tooltipId;
		}

		return subDescription ? subDescriptionId : undefined;
	}

	public static getAriaLabel(label: React.ReactNode, labelVisible: boolean | undefined): string | undefined {
		if (labelVisible === false && typeof label === 'string') {
			return label;
		}

		return undefined;
	}
}
